import PropTypes from "prop-types";

import { useGetAssetType } from "@/entities/asset-type";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import AssetTypeForm from "./AssetTypeForm.component";

const AssetTypeFormWrapper = ({ assetTypeId }) => {
  const { assetType, isLoading } = useGetAssetType(assetTypeId);

  if (!assetTypeId) return <AssetTypeForm />;

  return (
    <FetchItemWrapper
      item={assetType}
      loading={isLoading}
      renderContent={(assetType) => <AssetTypeForm model={assetType} />}
    />
  );
};

AssetTypeFormWrapper.propTypes = {
  assetTypeId: PropTypes.number,
};

export default AssetTypeFormWrapper;
